module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "new-password"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('h2', {
    staticClass: "subscribe-title"
  }, [_vm._v(_vm._s(_vm.$t('login.register_new_password')))]), _vm._v(" "), _c('h3', {
    staticClass: "subscribe-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('login.type_new_password_for_your_account')))])]), _vm._v(" "), _c('div', {
    staticClass: "reset-password-container login-box"
  }, [_c('flash-message'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "ls-form row",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('fieldset', {
    staticClass: "ls-md-margin-bottom"
  }, [_c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('login.new_password'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text ls-hidden-accessible"
  }, [_vm._v(_vm._s(_vm.$t('login.attributes.password')))]), _vm._v(" "), _c('div', {
    staticClass: "ls-prefix-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": _vm.$t('login.placeholder.new_password'),
      "name": _vm.$t('login.new_password')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ls-label-text-prefix ls-toggle-pass ls-ico-eye",
    attrs: {
      "data-toggle-class": "ls-ico-eye, ls-ico-eye-blocked",
      "data-target": "#password",
      "href": "javascript:void(0)"
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('login.new_password'))),
      expression: "errors.has($t('login.new_password'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('login.new_password'))))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('login.confirm_password'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text ls-hidden-accessible"
  }, [_vm._v(_vm._s(_vm.$t('login.attributes.confirm_password')))]), _vm._v(" "), _c('div', {
    staticClass: "ls-prefix-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirmation),
      expression: "passwordConfirmation"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:' + _vm.$t('login.new_password')),
      expression: "'required|confirmed:' + $t('login.new_password')"
    }],
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('login.placeholder.confirm_password'),
      "name": _vm.$t('login.confirm_password')
    },
    domProps: {
      "value": (_vm.passwordConfirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirmation = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa",
    class: {
      'fa-check': _vm.passwordConfirmation && !_vm.errors.first(_vm.$t('login.confirm_password'))
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('login.confirm_password'))),
      expression: "errors.has($t('login.confirm_password'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('login.confirm_password'))))])])]), _vm._v(" "), _c('button', {
    staticClass: "ls-btn-primary ls-btn-block ls-btn-lg ls-full-width ls-md-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('application.reset_password.new_password')))]), _vm._v(" "), _c('p', {
    staticClass: "ls-md-margin-bottom ls-txt-center"
  }, [_vm._v(_vm._s(_vm.$t('login.attributes.go_to_link')) + " "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'auth'
      },
      "title": _vm.$t('login.signin')
    }
  }, [_vm._v(_vm._s(_vm.$t('login.signin')))]), _vm._v(" " + _vm._s(_vm.$t('login.attributes.or')) + " "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signup'
      },
      "title": _vm.$t('login.no_register')
    }
  }, [_vm._v(_vm._s(_vm.$t('login.register_now')))])], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "ls-login-logo"
  }, [_c('img', {
    attrs: {
      "src": require("./../../../assets/img/logo.svg"),
      "width": "140"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ls-label-text-prefix"
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ls-label-text-prefix"
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-faf81cb4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/auth/NewPassword.vue
// module id = 842
// module chunks = 1